import React, { useEffect, useRef } from 'react';
import styles from './ScrollProgress.module.css';

const ScrollProgress = () => {
  const barRef = useRef(null);
  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      if (barRef.current) barRef.current.style.width = `${pct}%`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={styles.bar} ref={barRef} />;
};

export default ScrollProgress;
